import { render, staticRenderFns } from "./Veteran.vue?vue&type=template&id=64c1899a&"
import script from "./Veteran.vue?vue&type=script&lang=js&"
export * from "./Veteran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Veteran.vue"
export default component.exports